import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { Link } from 'react-router-dom';
import { Button, Table, Row, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { BasicHeader } from '../../components/basic_header';
import { reports_quick_menu } from '../../util/ui_util';

const plugin_cols = [{
  title: "Plugin Name",
  dataIndex: 'name',
  key: 'name'
}, {
  title: "",
  dataIndex: 'id',
  key: 'id',
  render: (id) => <Link to={`/reports/adhoc/${id}`}>
    <Button type='link'>Create</Button>
  </Link>
}]
class ReportPluginList extends Component {
  constructor(props) {
    super(props)

    this.state = {

    };
    this.list_plugins = RESTExecutor.list().config({
      label: 'report_plugins'
    }).connect(props.domains.reports);

    this.list_plugins.execute()

  };

  render() {
    let list_plugins_resp = this.list_plugins.response();
    let rowsData = (list_plugins_resp.result && list_plugins_resp.result.rows) || [];
    let filteredData = JSON.parse(JSON.stringify(rowsData));
    if (this.state.query) {
      filteredData = filteredData.filter(({ name = "", id = "", description = "" }) => {
        name = name.toLowerCase();
        id = id.toLowerCase();
        description = description.toLowerCase();
        return name.includes(this.state.query.toLowerCase())
          || id.includes(this.state.query.toLowerCase())
          || description.includes(this.state.query.toLowerCase())
          ;
      });
    }
    return (
      <div>
         <BasicHeader
                    no_back
                    title="Adhocs"
                    menu_items={reports_quick_menu}

                    
                />
         <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
 <Input.Search
                placeholder="Search For"
                autoFocus
                style={{
                }}
                value={this.state.query}
                onChange={(e) => {
                  this.setState({ query: e.target.value })
                }}
              />
              </div>
        </div>

      <div className='default-card'>
        <Table
        scroll={{x:true}}
          bordered={false}
          className='main-table'
          columns={plugin_cols}
          dataSource={filteredData}
          loading={list_plugins_resp.fetching}
          size='small'
        />


      </div>
      </div>
    );
  }

  componentDidMount(){
    try{
      window.header_assigner.assignTitle(`Adhoc List`);

  }catch(e){}
  }
}

export default withDomains(ReportPluginList, "reports");
